import styled from 'styled-components';

const Wrapper = styled.div`
  padding: 20px;
`;

export default {
  Wrapper,
};
